import { render } from "./Hero.vue?vue&type=template&id=d04205de&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=d04205de&scoped=true&lang=scss"

import exportComponent from "/home/marko/Documents/Projects/praksa/petikom-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d04205de"]])

export default __exports__